import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';

interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
}
const TransactionEarningHistoryTabBarMWeb = ({ onChangeTab, activeTab, routes = [] }: Props) => {
  return (
    <Tabs
      onChange={onChangeTab}
      value={activeTab}
      style={{
        padding: 0,
        minHeight: '40px',
        marginTop: '10px',
        width: '80%'
      }}
      TabIndicatorProps={{
        style: { background: 'none' }
      }}>
      {routes.map((item: any, index: any) => {
        const { key, title } = item;
        const isActive = activeTab === index;
        return (
          <Tab
            key={key}
            sx={{ width: '150px' }}
            style={{
              flex: 1,
              padding: 0,
              fontFamily: 'Poppins',
              fontSize: '1.3rem',
              fontWeight: isActive ? 600 : 'normal',
              textTransform: 'none',
              minHeight: '40px',
              color: isActive ? '#000' : '#fff',
              backgroundColor: isActive ? '#ffc600' : '#38414d',
              borderTopLeftRadius: index === 0 ? '4px' : '',
              borderTopRightRadius: index === 1 ? '4px' : '',
              borderBottomLeftRadius: index === 0 ? '4px' : '',
              borderBottomRightRadius: index === 1 ? '4px' : ''
            }}
            label={`${title}`}
            value={index}
          />
        );
      })}
    </Tabs>
  );
};
export default React.memo(TransactionEarningHistoryTabBarMWeb);
